import NotificationNotipayListPage from "./pages/NotificationNotipayListPage.vue";
import NotificationNotipayViewPage from "./pages/NotificationNotipayViewPage.vue";
export default {
    NotificationNotipayListPage,
    NotificationNotipayViewPage,
};
